import { yupResolver } from '@hookform/resolvers/yup';
import { Grid, Stack } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { saveFormstackKey } from 'wisestep-api';
import {
  ControlledTextInput,
  Item,
  WsTypography,
  WsDialog,
  WsDialogSize,
  WsTypoColors,
  WsTypoVariants,
  ChatBoxHeader,
  Label,
  WsButton,
} from 'wisestep-base';
import { object, string } from 'yup';

import { success } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

export interface IInvoiceFormstackKey {
  closeDialog: () => void;
  apiKey: string;
  secretKey: string;
}

const InvoiceFormstackKey = ({ closeDialog, secretKey, apiKey }: IInvoiceFormstackKey) => {
  const methods = useForm({
    resolver: yupResolver(
      object().shape({
        apiKey: string().required('Api key is required'),
        secretKey: string().required('Secret key is required'),
      })
    ),
    defaultValues: {
      apiKey: apiKey,
      secretKey: secretKey,
    },
  });
  const { handleSubmit } = methods;
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [openStatusModal, setOpenStatusModal] = useState<boolean>(true);

  const onSubmit = async (data) => {
    await saveFormstackKey(data);
    setOpenStatusModal(false);
    setNotification(success('Keys have been saved successfully'));
  };

  return (
    <WsDialog openDialog={openStatusModal} size={WsDialogSize.MEDIUM} onClose={closeDialog}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit((data) => onSubmit(data))}>
          <ChatBoxHeader>
            <Grid container item xs={12}>
              <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.PRIMARY} bold={true}>
                Formstack Api Keys
              </WsTypography>
            </Grid>
          </ChatBoxHeader>
          <Item>
            <Grid container spacing={2}>
              <Grid spacing={1} marginLeft={15}>
                <Label>Api Key</Label>
                <ControlledTextInput
                  name="apiKey"
                  labelText=""
                  type="text"
                  variant="outlined"
                  sx={{ width: '60vh' }}
                />
              </Grid>
              <Grid spacing={1} marginLeft={15}>
                <Label>Secret key</Label>
                <ControlledTextInput
                  name="secretKey"
                  labelText=""
                  type="text"
                  variant="outlined"
                  sx={{ width: '60vh' }}
                />
              </Grid>

              <Stack
                p={1}
                mt={2}
                columnGap={2}
                direction="row"
                justifyContent="flex-end"
                marginLeft="60vh"
              >
                <WsButton variant="contained" size="medium" onClick={closeDialog}>
                  Cancel
                </WsButton>
                <WsButton variant="contained" size="medium" type="submit">
                  Save
                </WsButton>
              </Stack>
            </Grid>
          </Item>
        </form>
      </FormProvider>
    </WsDialog>
  );
};

export default InvoiceFormstackKey;
